import type en from '../en/devices'
import type { Translation } from '../types'

/** The device brands: registering a device and its page */
const devices: Translation<typeof en> = {
  "devices.registered": "Gerät registriert",
  "devices.registrationFailed": "Registrierung fehlgeschlagen",
  "devices.siteRegistered": "{name} registriert",
  "devices.registerAnother": "Weiteres registrieren",
  "devices.openDevice": "Gerät öffnen",
  "devices.viewAllSites": "Alle Standorte anzeigen",
  "devices.deviceAddress": "Geräteadresse *",
  "devices.username": "Benutzername *",
  "devices.password": "Passwort *",
  "devices.siteName": "Name des Standorts",
  "devices.connectRegister": "Verbinden und registrieren",
  "devices.directDevice": "Direktes Gerät",
  "devices.deviceUrl": "Geräte-URL *",
  "devices.reachableVpn": "Muss von diesem Server aus erreichbar sein – meist über den VPN-Tunnel.",
  "devices.storedEncrypted": "Verschlüsselt gespeichert.",
  "devices.imported": { one: "{count} Gerät importiert", other: "{count} Geräte importiert" },
  "devices.mikrotik.transport.rest": "REST-API (RouterOS 7)",
  "devices.mikrotik.transport.apiSsl": "API-Protokoll über TLS",
  "devices.mikrotik.transport.api": "API-Protokoll (unverschlüsselt)",
  "devices.mikrotik.radios": { one: "{count} Funkmodul", other: "{count} Funkmodule" },
  "devices.mikrotik.connectedOver": "Verbunden über: {transport}",
  "devices.mikrotik.registerTitle": "MikroTik registrieren",
  "devices.mikrotik.registerSubtitle": "Ein Router, Access Point oder Punkt-zu-Punkt-/Punkt-zu-Mehrpunkt-Funkgerät",
  "devices.mikrotik.addressHint": "Muss von diesem Server aus erreichbar sein – meist seine VPN-Adresse. Die Verbindungsart wird erkannt: REST unter RouterOS 7, der API-Dienst (8729 oder 8728) unter RouterOS 6.43 und neuer.",
  "devices.mikrotik.forceHint": "Um eine zu erzwingen, schreiben Sie",
  "devices.or": "oder",
  "devices.mikrotik.accountHint": "Verwenden Sie ein Konto mit vollen Rechten, wenn Sie das Gerät von hier aus konfigurieren möchten; für die Überwachung genügt ein Konto mit Leserechten. Verschlüsselt gespeichert.",
  "devices.mikrotik.siteNameHint": "(optional – standardmäßig die Identität des Geräts)",
  "devices.mikrotik.siteNamePlaceholder": "z. B. Sektor Nord",
  "devices.mikrotik.radioLinkTitle": "Für eine Richtfunkstrecke",
  "devices.mikrotik.radioLinkText": " registrieren Sie jedes Ende als eigenen Standort. Der Access Point zeigt dann jede Station mit Signal und Rate; eine Station, die hier ebenfalls registriert ist, wird selbst an einem einfachen WLAN-Access-Point als Verbindung erkannt.",
  "devices.peplink.foundOrgs": { one: "{count} Organisation gefunden", other: "{count} Organisationen gefunden" },
  "devices.peplink.discoveryFailed": "Suche fehlgeschlagen",
  "devices.peplink.telemetryNote": "SpeedFusion- und WAN-Telemetrie erscheinen nach der ersten Synchronisierung.",
  "devices.peplink.registerTitle": "Peplink registrieren",
  "devices.peplink.registerSubtitle": "Verbindung über InControl2 oder direkt mit einem Router",
  "devices.peplink.ic2Desc": "Importiert jedes Gerät einer Organisation oder Gruppe.",
  "devices.peplink.directDesc": "Fragt einen Balance/MAX-Router lokal ab.",
  "devices.peplink.clientId": "Client-ID *",
  "devices.peplink.clientSecret": "Client-Secret *",
  "devices.createUnder": "Erstellen unter",
  "devices.peplink.ic2Url": "IC2-API-URL",
  "devices.peplink.discoverOrgs": "Organisationen suchen",
  "devices.peplink.organisation": "Organisation *",
  "devices.peplink.group": "Gruppe",
  "devices.peplink.blankAllGroups": "(leer = alle Gruppen)",
  "devices.peplink.allGroups": "Alle Gruppen",
  "devices.peplink.siteNamePlaceholder": "z. B. Boot 1 – MAX Transit",
  "devices.teltonika.importedFromRms": { one: "{count} Gerät aus RMS importiert", other: "{count} Geräte aus RMS importiert" },
  "devices.teltonika.telemetryNote": "Mobilfunk-Telemetrie erscheint nach der ersten Synchronisierung.",
  "devices.teltonika.registerTitle": "Teltonika registrieren",
  "devices.teltonika.registerSubtitle": "Verbindung über die RMS-Cloud oder direkt mit einem Router",
  "devices.teltonika.rmsCloud": "RMS-Cloud",
  "devices.teltonika.rmsDesc": "Importiert jedes Gerät Ihres RMS-Unternehmens. Ideal für Flotten.",
  "devices.teltonika.directDesc": "Fragt einen RutOS-Router über seine lokale API ab.",
  "devices.teltonika.pat": "Persönliches Zugriffstoken *",
  "devices.teltonika.createInRms": "Erstellen in RMS unter",
  "devices.teltonika.rmsUrl": "RMS-API-URL",
  "devices.teltonika.defaultRms": "Für das öffentliche Standard-RMS leer lassen.",
  "devices.teltonika.siteNamePlaceholder": "z. B. Transporter 3 – RUTX11",
  "devices.unifihost.consoles": { one: "{count} Konsole", other: "{count} Konsolen" },
  "devices.unifihost.found": "{consoles} und {sites} gefunden",
  "devices.unifihost.verificationFailed": "Überprüfung fehlgeschlagen",
  "devices.unifihost.importedSites": { one: "{count} Standort importiert", other: "{count} Standorte importiert" },
  "devices.unifihost.importFailed": "Import fehlgeschlagen",
  "devices.unifihost.doneNote": "Site Manager liefert schreibgeschützte Flotten-Telemetrie und ISP-Kennzahlen. Fügen Sie für die Konfiguration auch den lokalen Controller als UniFi-Standort hinzu.",
  "devices.unifihost.importMore": "Weitere importieren",
  "devices.unifihost.title": "UniFi Site Manager verbinden",
  "devices.unifihost.subtitle": "Flottenweite Überwachung aller UniFi-Konsolen Ihres Kontos",
  "devices.unifihost.apiKey": "API-Schlüssel *",
  "devices.unifihost.apiKeyPlaceholder": "UniFi-Site-Manager-API-Schlüssel",
  "devices.unifihost.createAt": "Erstellen unter",
  "devices.unifihost.baseUrl": "API-Basis-URL",
  "devices.unifihost.verifyDiscover": "Prüfen und suchen",
  "devices.unifihost.importAs": "Importieren als",
  "devices.unifihost.perSite": "Ein Standort pro UniFi-Site",
  "devices.unifihost.recommended": "{sites} – empfohlen",
  "devices.unifihost.perConsole": "Ein Standort pro Konsole",
  "devices.unifihost.consolesToImport": "Zu importierende Konsolen",
  "devices.unifihost.console": "Konsole",
  "devices.unifihost.importConsoles": { one: "{count} Konsole importieren", other: "{count} Konsolen importieren" },
  "devices.velanox.registeredFromEndpoint": { one: "{count} Box vom Endpoint registriert", other: "{count} Boxen vom Endpoint registriert" },
  "devices.velanox.standaloneRegistered": "Eigenständige Box registriert: {name}",
  "devices.velanox.boxesRegistered": { one: "{count} Box registriert", other: "{count} Boxen registriert" },
  "devices.velanox.boxRegistered": "Box registriert",
  "devices.velanox.endpointNote": "Für jede Box am Endpoint wurde ein Standort angelegt. Sie werden automatisch synchronisiert.",
  "devices.velanox.boxNote": "Die eigenständige Box wurde als Standort hinzugefügt.",
  "devices.velanox.registerTitle": "Velanox-Standort registrieren",
  "devices.velanox.registerSubtitle": "Verbinden Sie einen Velanox-One-Speed-Endpoint oder eine eigenständige Box",
  "devices.velanox.endpoint": "Endpoint",
  "devices.velanox.endpointDesc": "Bündelt mehrere Boxen. Legt automatisch einen Standort pro Box an.",
  "devices.velanox.standalone": "Eigenständige Box",
  "devices.velanox.standaloneDesc": "Eine einzelne, direkt abgefragte Box.",
  "devices.velanox.endpointName": "Name des Endpoints",
  "devices.velanox.endpointNamePlaceholder": "z. B. Endpoint Amsterdam",
  "devices.velanox.endpointNameHint": "Dient als Bezeichnung – die Namen der einzelnen Boxen kommen aus der API.",
  "devices.velanox.siteNamePlaceholder": "z. B. Starlinkhuren mobile Einheit",
  "devices.velanox.url": "Velanox-URL *",
  "devices.velanox.baseUrlEndpoint": "Basis-URL des Flask-Servers des Endpoints.",
  "devices.velanox.baseUrlBox": "Basis-URL des HTTP-Servers der eigenständigen Box.",
  "devices.velanox.token": "Integrationstoken *",
  "devices.velanox.setVia": "Festgelegt über",
  "devices.velanox.onNode": "auf dem Velanox-Knoten.",
  "devices.velanox.descriptionPlaceholder": "Optionale Notizen zu dieser Verbindung",
  "devices.actionFailed": "Aktion fehlgeschlagen",
  "devices.actionSent": "„{action}“ gesendet",
  "devices.action.reboot": "Neustart",
  "devices.action.firmware_check": "Firmware-Prüfung",
  "devices.action.tunnel_reconnect": "Tunnel neu verbinden",
  "devices.action.wan_enable": "WAN einschalten",
  "devices.action.wan_disable": "WAN ausschalten",
  "devices.action.send_sms": "SMS senden",
  "devices.action.restart_modem": "Modem neu starten",
  "devices.action.switch_sim": "SIM wechseln",
  "devices.action.restart_network": "Netzwerk neu starten",
  "devices.action.roll_key": "Schlüssel erneuern",
  "devices.action.restart_service": "Dienst neu starten",
  "devices.action.get_stats": "Statistiken abrufen",
  "devices.action.fetch_logs": "Protokolle abrufen",
  "devices.action.starlink_stow": "Antenne verstauen",
  "devices.action.starlink_unstow": "Antenne ausklappen",
  "devices.action.starlink_reboot": "Antenne neu starten",
  "devices.upFor": "läuft seit {duration}",
  "devices.memory": "Arbeitsspeicher",
  "devices.temperature": "Temperatur",
  "devices.openMap": "Karte öffnen",
  "devices.controls": "Gerätesteuerung",
  "devices.checkFirmware": "Firmware prüfen",
  "devices.sendSms": "SMS senden",
  "devices.reboot": "Neu starten",
  "devices.sms.recipient": "Empfängernummer",
  "devices.sms.message": "Nachricht",
  "devices.sms.charges": "Wird von der SIM des Routers gesendet. Es fallen Gebühren des Anbieters an.",
  "devices.signal.0": "Kein Signal",
  "devices.signal.1": "Sehr schwach",
  "devices.signal.2": "Schwach",
  "devices.signal.3": "Mittel",
  "devices.signal.4": "Gut",
  "devices.signal.5": "Ausgezeichnet",
  "devices.unknown": "unbekannt",
  "devices.unknownError": "Unbekannter Fehler",
  "devices.up": "Aktiv",
  "devices.connected": "Verbunden",
  "devices.loss": "{percent} % Verlust",
  "devices.interface": "Schnittstelle",
  "devices.ipAddress": "IP-Adresse",
  "devices.gateway": "Gateway",
  "devices.enable": "Einschalten",
  "devices.disable": "Ausschalten",
  "devices.device": "Gerät",
  "devices.firmware": "Firmware",
  "devices.mikrotik.updateCheckDone": "Update-Prüfung abgeschlossen",
  "devices.mikrotik.installedLatest": "Installiert {installed}, neueste {latest}",
  "devices.mikrotik.noNewer": "Keine neuere Version gemeldet",
  "devices.mikrotik.backupSaved": "Sicherung gespeichert",
  "devices.mikrotik.rebootSent": "Neustart gesendet",
  "devices.mikrotik.backInMinute": "Das Gerät ist in ein bis zwei Minuten wieder da.",
  "devices.mikrotik.renamePrompt": "Name für diese Verbindung",
  "devices.mikrotik.renameFailed": "Umbenennen fehlgeschlagen",
  "devices.mikrotik.forgetConfirm": "{name} vergessen? Verwenden Sie dies für eine absichtlich entfernte Station – sie erscheint von selbst wieder, wenn sie sich neu verbindet.",
  "devices.mikrotik.forgetFailed": "Die Verbindung konnte nicht entfernt werden",
  "devices.mikrotik.device": "MikroTik-Gerät",
  "devices.mikrotik.updateBadge": "Update {version}",
  "devices.mikrotik.via": "über {transport}",
  "devices.mikrotik.configure": "Konfigurieren",
  "devices.mikrotik.checkUpdates": "Updates prüfen",
  "devices.mikrotik.backup": "Sicherung",
  "devices.mikrotik.rebootConfirm": "Dieses Gerät neu starten? Verbindungen darüber fallen für ein bis zwei Minuten aus.",
  "devices.mikrotik.cannotReach": "Das Gerät ist nicht erreichbar{reason}. Die Verbindungen unten zeigen den zuletzt gesehenen Stand.",
  "devices.mikrotik.links": "Verbindungen",
  "devices.mikrotik.wifiClients": { one: "{count} WLAN-Client", other: "{count} WLAN-Clients" },
  "devices.mikrotik.radioLinks": "Richtfunkstrecken",
  "devices.mikrotik.noLinks": "Noch keine Verbindungen gesehen. Sie erscheinen nach der ersten Synchronisierung, sobald eine Station verbunden ist.",
  "devices.mikrotik.farEnd": "Gegenstelle",
  "devices.mikrotik.signal": "Signal",
  "devices.mikrotik.rate": "Rate ↑ / ↓",
  "devices.mikrotik.quality": "Qualität",
  "devices.mikrotik.distance": "Entfernung",
  "devices.mikrotik.roleAp": "Access Point",
  "devices.mikrotik.roleStation": "Station",
  "devices.mikrotik.onInterface": "an {interface}",
  "devices.mikrotik.linkDown": "Verbindung unterbrochen",
  "devices.mikrotik.seen": "gesehen {when}",
  "devices.mikrotik.rename": "Umbenennen",
  "devices.mikrotik.forget": "Diese Verbindung vergessen",
  "devices.mikrotik.noWireless": "Keine Funkschnittstellen",
  "devices.mikrotik.mode": "Modus",
  "devices.mikrotik.channel": "Kanal",
  "devices.mikrotik.state": "Zustand",
  "devices.mikrotik.disabled": "deaktiviert",
  "devices.mikrotik.running": "aktiv",
  "devices.mikrotik.notConnected": "nicht verbunden",
  "devices.mikrotik.uplinks": "Uplinks",
  "devices.mikrotik.noUplink": "Kein Uplink gefunden. Eine Schnittstelle zählt als Uplink, wenn sie in der Schnittstellenliste „WAN“ steht oder die Standardroute trägt.",
  "devices.mikrotik.address": "Adresse",
  "devices.mikrotik.order": "Reihenfolge",
  "devices.mikrotik.signalAria": "Signal {percent} Prozent",
  "devices.peplink.cannotReach": "Das Peplink-Gerät ist nicht erreichbar – prüfen Sie die Zugangsdaten",
  "devices.peplink.wansUp": "WANs aktiv",
  "devices.peplink.tunnels": "SpeedFusion-Tunnel",
  "devices.storedLine": "Zuletzt gelesen {when} — der Router wird jetzt gelesen…",
  "devices.storedLineNever": "Noch nicht gelesen — der Router wird jetzt gelesen…",
  "devices.peplink.wanLinks": "WAN-Verbindungen",
  "devices.peplink.unknownCarrier": "Unbekannter Anbieter",
  "devices.peplink.rebootConfirm": "Dieses Peplink-Gerät neu starten? Alle Verbindungen fallen für 1–2 Minuten aus.",
  "devices.teltonika.cannotReach": "Das Teltonika-Gerät ist nicht erreichbar – prüfen Sie Zugangsdaten und Verbindung",
  "devices.teltonika.modems": "Modems",
  "devices.teltonika.power.title": "Stromversorgung",
  "devices.teltonika.power.noBattery": "Kein Akku",
  "devices.teltonika.power.onMains": "Am Netzstrom",
  "devices.teltonika.power.onBattery": "Mit Notstrom seit {time} ({duration})",
  "devices.teltonika.power.notKnown": "Nicht bekannt",
  "devices.teltonika.power.has": "Hat Notstrom (USV)",
  "devices.teltonika.power.notChanged": "Die Notstrom-Einstellung wurde nicht geändert",
  "devices.teltonika.noModems": "Keine Mobilfunkmodems gemeldet",
  "devices.teltonika.noOperator": "Kein Anbieter",
  "devices.teltonika.band": "Band {band}",
  "devices.teltonika.dataUsage": "Datenverbrauch",
  "devices.teltonika.restartModem": "Modem neu starten",
  "devices.teltonika.switchSimConfirm": "{modem} auf den anderen SIM-Steckplatz umschalten?",
  "devices.teltonika.switchSim": "SIM wechseln",
  "devices.teltonika.wanInterfaces": "WAN-Schnittstellen",
  "devices.teltonika.noWans": "Keine WAN-Schnittstellen gemeldet",
  "devices.teltonika.rebootConfirm": "Dieses Gerät neu starten? Es ist 1–2 Minuten offline.",
  "devices.teltonika.vpnMode": "Auf der Werkbank programmiert",
  "devices.teltonika.vpnModeDesc": "Anhand der Seriennummer, mit eigenem VPN-Zertifikat",
  "devices.teltonika.serial": "Seriennummer",
  "devices.teltonika.serialHint": "Wie auf dem Etikett; Leerzeichen spielen keine Rolle. Dieselbe Seriennummer noch einmal aktualisiert diesen Router und gibt ihm ein neues Zertifikat.",
  "devices.teltonika.model": "Modell",
  "devices.teltonika.modelHint": "Das Modell darf leer bleiben: Der Router meldet sein eigenes bei der ersten Verbindung.",
  "devices.teltonika.vpnLogin": "Velanox-Anmeldung auf dem Router",
  "devices.teltonika.vpnLoginHint": "Der Benutzer, mit dem sich Velanox über den Tunnel anmeldet. Das Passwort wird verschlüsselt gespeichert und nie wieder angezeigt.",
  "devices.teltonika.addRouter": "Router hinzufügen",
  "devices.teltonika.routerAdded": "Router hinzugefügt",
  "devices.teltonika.routerAddedText": "Sein VPN-Zertifikat ist ausgestellt: Laden Sie seine .ovpn-Datei von dieser Seite auf den Router.",
  "devices.teltonika.addFailed": "Der Router wurde nicht hinzugefügt",
  "devices.teltonika.vpn.waiting": "Wartet auf den Router",
  "devices.teltonika.vpn.noAccount": "Dieser Router hat noch kein VPN-Zertifikat: Fügen Sie ihn mit derselben Seriennummer erneut hinzu, um eines auszustellen.",
  "devices.teltonika.vpn.newCertConfirm": "Ein neues VPN-Zertifikat für {name} ausstellen? Das aktuelle funktioniert sofort nicht mehr; der Router bleibt ohne VPN, bis er die neue Datei hat.",
  "devices.teltonika.vpn.newCertDoneText": "Laden Sie die neue .ovpn-Datei herunter und spielen Sie sie auf den Router.",
  "devices.teltonika.vpn.stepsTitle": "Auf den Router laden (RutOS-WebUI)",
  "devices.teltonika.vpn.step1": "Services → VPN → OpenVPN: eine Client-Instanz namens velanox hinzufügen.",
  "devices.teltonika.vpn.step2": "Einschalten, „{option}“ einschalten und {file} wählen. Speichern.",
  "devices.teltonika.vpn.step3": "Der Router wählt sich ein; diese Karte zeigt innerhalb weniger Minuten Verbunden.",
  "devices.unifihost.consoleName": "UniFi-Konsole",
  "devices.unifihost.readOnly": "Schreibgeschützte Cloud-Ansicht. Um Einstellungen zu ändern, registrieren Sie den lokalen Controller als UniFi-Standort.",
  "devices.unifihost.online": "online",
  "devices.unifihost.offline": "offline",
  "devices.unifihost.onConsole": "auf dieser Konsole",
  "devices.unifihost.connected": "verbunden",
  "devices.unifihost.updates": "Updates",
  "devices.unifihost.firmwareAvailable": "Firmware verfügbar",
  "devices.unifihost.ispPerformance": "ISP-Leistung",
  "devices.unifihost.last24h": "Letzte 24 Std.",
  "devices.unifihost.last30d": "Letzte 30 Tage",
  "devices.unifihost.noIsp": "Für diese Konsole wurden keine ISP-Kennzahlen gemeldet",
  "devices.unifihost.updateBadge": "⬆ Update",
  "devices.velanox.cannotReach": "Die Velanox-Box ist nicht erreichbar – prüfen Sie Integrationstoken und URL",
  "devices.velanox.keyRollPending": "🔑 Schlüsselerneuerung ausstehend",
  "devices.velanox.wans": { one: "{count} WAN", other: "{count} WANs" },
  "devices.velanox.encrypted": "🔒 verschlüsselt",
  "devices.velanox.na": "k. A.",
  "devices.velanox.rttBonded": "RTT (gebündelt)",
  "devices.velanox.packetLoss": "Paketverlust",
  "devices.velanox.wanPaths": "WAN-Pfade",
  "devices.velanox.noWanPaths": "Keine WAN-Pfade",
  "devices.velanox.jitter": "Jitter",
  "devices.velanox.loss": "Verlust",
  "devices.velanox.weight": "Gewicht",
  "devices.velanox.anchor": "Anker",
  "devices.velanox.alive": "Aktiv",
  "devices.velanox.roaming": "Roaming",
  "devices.velanox.boxControls": "Box-Steuerung",
  "devices.velanox.controlsNote": "Steueraktionen werden über den Verwaltungskanal an die Box weitergeleitet. Ein Neustart verursacht einen kurzen Ausfall.",
  "devices.velanox.rollKey": "Schlüssel erneuern",
  "devices.velanox.restartService": "Dienst neu starten",
  "devices.velanox.getStats": "Statistiken abrufen",
  "devices.velanox.fetchLogs": "Protokolle abrufen",
  "devices.velanox.rebootBox": "Box neu starten",
  "devices.velanox.rebootConfirm": "Diese Velanox-Box neu starten? Das verursacht einen kurzen Ausfall.",
  "devices.velanox.starlinkUnavailable": "Der Starlink-Status ist nicht verfügbar{reason}.",
  "devices.velanox.loadingStarlink": "Starlink-Status wird geladen…",
  "devices.velanox.noDriver": "Mit dieser Box ist kein Starlink-Treiber verbunden. Die Box meldet driver: null.",
  "devices.velanox.capabilities": "Starlink-Funktionen",
  "devices.velanox.driver": "Treiber: {driver}",
  "devices.velanox.reposition": "Neu ausrichten ist auf echter Starlink-Hardware nie verfügbar – die Antennen richten sich selbst aus.",
  "devices.velanox.dishControls": "Antennensteuerung",
  "devices.velanox.greyedNote": "Schaltflächen sind ausgegraut, wenn die Antenne diese Funktion nicht unterstützt.",
  "devices.velanox.grpcNote": "Hinweis: Die Antennensteuerung über den Endpoint liefert 501 (Integration ausstehend). Verwenden Sie für die Antennensteuerung den Modus eigenständige Box.",
  "devices.velanox.stow": "Antenne verstauen",
  "devices.velanox.unstow": "Antenne ausklappen",
  "devices.velanox.rebootDish": "Antenne neu starten",
  "devices.velanox.rebootDishConfirm": "Die Starlink-Antenne neu starten?",
  "devices.velanox.dishStatus": "Antennenstatus",
  "devices.velanox.notSupported": "{label} wird von dieser Box nicht unterstützt",
  "devices.velanox.preset.firmware": "Firmware-Status",
  "devices.velanox.preset.gateway": "Gateway-Status",
  "devices.velanox.preset.firewall": "Firewall-Regeln",
  "devices.velanox.preset.dhcp": "DHCP-Leases",
  "devices.velanox.preset.interfaces": "Schnittstellen",
  "devices.velanox.preset.arp": "ARP-Tabelle",
  "devices.velanox.invalidJson": "Der Body ist kein gültiges JSON",
  "devices.velanox.requestFailed": "Anfrage fehlgeschlagen",
  "devices.velanox.passThrough": "OPNsense-Durchreichung. Die Box setzt die eingestellte Zugriffsstufe durch – abgelehnte Aufrufe liefern 403. Stufe 3 kann die Firewall neu starten oder umkonfigurieren.",
  "devices.velanox.quickPresets": "Schnellvorlagen",
  "devices.velanox.httpMethod": "HTTP-Methode",
  "devices.velanox.apiPath": "API-Pfad",
  "devices.velanox.requestBody": "Request-Body (JSON, optional)",
  "devices.velanox.response": "Antwort",
  "devices.unifihost.connectedSince": "Verbunden seit",
  "devices.unifihost.managedBy": "Verwaltet von",
  "devices.unifihost.mgmt.GATEWAY": "Gateway",
  "devices.unifihost.mgmt.SWITCH": "Switch",
  "devices.unifihost.mgmt.UNMANAGED": "Nicht verwaltet",
  "devices.unifihost.defaultNetwork": "Standard",
  "devices.unifihost.security": "Sicherheit",
  "devices.unifihost.bands": "Frequenzbänder",
  "devices.unifihost.network": "Netzwerk",
  "devices.unifihost.nativeNetwork": "Natives Netzwerk",
  "devices.unifihost.sec.OPEN": "Offen",
  "devices.unifihost.sec.WPA2_PERSONAL": "WPA2-Personal",
  "devices.unifihost.sec.WPA3_PERSONAL": "WPA3-Personal",
  "devices.unifihost.sec.WPA2_WPA3_PERSONAL": "WPA2/WPA3-Personal",
  "devices.unifihost.sec.WPA2_ENTERPRISE": "WPA2-Enterprise",
  "devices.unifihost.sec.WPA3_ENTERPRISE": "WPA3-Enterprise",
  "devices.unifihost.sec.WPA2_WPA3_ENTERPRISE": "WPA2/WPA3-Enterprise",
  "devices.unifihost.why.rejected": "UniFi hat den API-Schlüssel für diese Konsole abgelehnt. Der Schlüssel muss dem Eigentümer der Konsole gehören.",
  "devices.unifihost.why.unsupported": "Diese Konsole kann diese Liste nicht über die Cloud liefern. Dafür ist UniFi OS 5.0.3 oder neuer nötig, für Netzwerke und WLAN außerdem UniFi Network 10 oder neuer.",
  "devices.unifihost.why.busy": "UniFi begrenzt die Anfragen an diese Konsole. Versuchen Sie es in einer Minute erneut.",
  "devices.unifihost.why.unreachable": "Die Konsole hat über die Cloud nicht geantwortet. Prüfen Sie, ob sie online ist.",
  "devices.unifihost.why.no_match": "Diese UniFi-Site ist nicht mehr auf ihrer Konsole vorhanden.",
  "devices.unifihost.why.failed": "UniFi hat diese Liste nicht geliefert.",
  "devices.unifilocal.open": "So wechseln Sie →",
  "devices.unifilocal.title": "Zum lokalen Controller wechseln",
  "devices.unifilocal.intro": "Die Konsole verbindet sich über einen eigenen VPN-Tunnel mit dem Dashboard; das Dashboard liest und ändert sie danach über ihren eigenen Controller. Der Standort behält seinen Namen, seine Meldungen und Abonnements.",
  "devices.unifilocal.noPermission": "Für den Wechsel sind die Rechte zum Bearbeiten von Standorten und zum Verwalten des VPN nötig.",
  "devices.unifilocal.step.account": "Erstellen Sie das VPN-Konto dieses Standorts",
  "devices.unifilocal.step.accountText": "Das Konto gibt der Konsole ein eigenes Zertifikat und eine feste Adresse im VPN-Netz des Unternehmens.",
  "devices.unifilocal.createAccount": "VPN-Konto erstellen",
  "devices.unifilocal.creating": "Konto wird erstellt…",
  "devices.unifilocal.accountReady": "Bereit: Tunneladresse {ip}",
  "devices.unifilocal.accountFailed": "Das VPN-Konto konnte nicht erstellt werden",
  "devices.unifilocal.step.download": "Laden Sie die VPN-Datei herunter",
  "devices.unifilocal.step.downloadText": "Die .ovpn-Datei enthält das eigene Zertifikat dieses Standorts. Behandeln Sie sie vertraulich und verwenden Sie sie nur auf dieser Konsole.",
  "devices.unifilocal.download": ".ovpn herunterladen",
  "devices.unifilocal.downloadFailed": "Download fehlgeschlagen",
  "devices.unifilocal.step.client": "Fügen Sie sie in UniFi als VPN-Client hinzu",
  "devices.unifilocal.client.1": "Öffnen Sie in UniFi Network Settings → VPN → VPN Client und wählen Sie Create New.",
  "devices.unifilocal.client.2": "VPN-Typ: OpenVPN. Geben Sie ihm einen Namen, zum Beispiel Velanox.",
  "devices.unifilocal.client.3": "Laden Sie die .ovpn-Datei als Konfigurationsdatei hoch.",
  "devices.unifilocal.client.4": "Lassen Sie Benutzername und Passwort leer: Die Datei enthält das Zertifikat.",
  "devices.unifilocal.client.5": "Leiten Sie keinen Datenverkehr hindurch: Lassen Sie die Routing-Assistenten aus und fügen Sie keine Traffic-Route hinzu. Nur das Dashboard nutzt diesen Tunnel.",
  "devices.unifilocal.client.6": "Wählen Sie Create. Die Verbindung steht innerhalb einer Minute.",
  "devices.unifilocal.waiting": "Warten auf die Verbindung des Tunnels…",
  "devices.unifilocal.connected": "Tunnel verbunden",
  "devices.unifilocal.step.firewall": "Lassen Sie das Dashboard die Konsole erreichen",
  "devices.unifilocal.firewall.why": "UniFi ordnet eine VPN-Client-Verbindung der Zone External zu, die die Konsole selbst nicht erreicht. Fügen Sie eine Firewall-Richtlinie hinzu, die das Dashboard hereinlässt:",
  "devices.unifilocal.firewall.1": "UniFi Network 10: Settings → Policy Engine → Policy Table → Create New Policy. Ältere Versionen: Settings → Security → Firewall.",
  "devices.unifilocal.firewall.2": "Quelle: Zone External, IP-Adresse {ip}.",
  "devices.unifilocal.firewall.3": "Ziel: Zone Gateway, Port 443 (TCP).",
  "devices.unifilocal.firewall.4": "Aktion: Allow.",
  "devices.unifilocal.serverIpFallback": "die Tunneladresse des Dashboards (die erste Adresse des Standortnetzes)",
  "devices.unifilocal.step.key": "Erstellen Sie einen lokalen API-Schlüssel",
  "devices.unifilocal.key.1": "In UniFi Network: Settings → Control Plane → Integrations → Create API Key.",
  "devices.unifilocal.key.2": "Kopieren Sie den Schlüssel: UniFi zeigt ihn nur einmal an.",
  "devices.unifilocal.step.switch": "Stellen Sie den Standort auf seinen lokalen Controller um",
  "devices.unifilocal.apiKey": "Lokaler API-Schlüssel",
  "devices.unifilocal.controllerUrl": "Controller-Adresse",
  "devices.unifilocal.controllerHint": "Aus der Tunneladresse übernommen. Ein selbst gehosteter UniFi Network Server: https://<Adresse>:8443",
  "devices.unifilocal.testSwitch": "Testen und wechseln",
  "devices.unifilocal.testing": "Wird getestet…",
  "devices.unifilocal.done": "Der Standort verwendet jetzt seinen lokalen Controller",
  "devices.unifilocal.why.rejected": "Die Konsole hat diesen API-Schlüssel abgelehnt. Erstellen Sie unter Control Plane → Integrations einen neuen.",
  "devices.unifilocal.why.not_found": "Die Konsole hat geantwortet, aber nicht unter dieser Adresse. Ein selbst gehosteter UniFi Network Server verwendet https://<Adresse>:8443.",
  "devices.unifilocal.why.unreachable": "Die Konsole hat über den Tunnel nicht geantwortet. Prüfen Sie, ob der VPN-Client verbunden ist (Schritt 3) und ob die Firewall-Richtlinie das Dashboard hereinlässt (Schritt 4).",
  "devices.unifilocal.why.no_vpn": "Dieser Standort hat noch keine Tunneladresse (Schritt 1).",
  "devices.unifilocal.why.failed": "Der Test ist fehlgeschlagen. Prüfen Sie die Adresse und den API-Schlüssel.",
  "devices.unifilocal.manual.intro": "Eine UniFi-OS-Konsole (Dream Machine, Cloud Gateway, Cloud Key) verbindet sich als OpenVPN-Client mit der .ovpn-Datei ihres Standorts, unverändert hochgeladen.",
  "devices.unifilocal.manual.download": "Laden Sie die .ovpn-Datei des Standorts herunter",
  "devices.unifilocal.manual.downloadText": "In der Tabelle der VPN-Konten oben, in der Zeile des Standorts.",
  "devices.unifilocal.manual.add": "Fügen Sie den Standort im Dashboard hinzu",
  "devices.unifilocal.manual.addText": "Ein über Site Manager hinzugefügter Standort: Öffnen Sie ihn und wählen Sie den blauen Balken; damit stellen Sie den Standort gemeinsam um. Ein neuer Standort: Fügen Sie einen UniFi-Standort mit der Controller-Adresse https://<Tunneladresse>/proxy/network und dem lokalen API-Schlüssel hinzu.",
  "devices.mikrotik.vpnModeHint": "Velanox stellt der Einheit ein eigenes VPN-Zertifikat aus. Laden Sie es auf die Einheit; sobald sie sich verbindet, fragt Velanox sie über ihren Tunnel ab. Jetzt muss nichts erreichbar sein.",
  "devices.mikrotik.serial": "Seriennummer",
  "devices.mikrotik.serialHint": "Wie auf dem Etikett; Leerzeichen und Groß-/Kleinschreibung spielen keine Rolle. Dieselbe Seriennummer erneut aktualisiert diese Einheit und gibt ihr ein neues Zertifikat.",
  "devices.mikrotik.unitRoleLabel": "Rolle",
  "devices.mikrotik.unitRoleNone": "Keine",
  "devices.mikrotik.unitRole.SENDER": "Sender",
  "devices.mikrotik.unitRole.RECEIVER": "Empfänger",
  "devices.mikrotik.unitNameHint": "(optional — sonst die Seriennummer)",
  "devices.mikrotik.vpnAccountHint": "Das Konto, mit dem sich Velanox über den Tunnel anmeldet. Verschlüsselt gespeichert, nie wieder angezeigt.",
  "devices.mikrotik.addUnit": "MikroTik hinzufügen",
  "devices.mikrotik.unitAdded": "MikroTik hinzugefügt",
  "devices.mikrotik.unitAddedText": "Sein VPN-Zertifikat ist ausgestellt: Laden Sie die Dateien von dieser Seite auf die Einheit.",
  "devices.mikrotik.addFailed": "Der MikroTik wurde nicht hinzugefügt",
  "devices.mikrotik.notDeployed.waiting": "Wartet auf VPN",
  "devices.mikrotik.notDeployed.offline": "Offline · nicht im Einsatz",
  "devices.mikrotik.waitingText": "Die Einheit hat sich noch nicht mit dem VPN verbunden; sobald sie sich verbindet, fragt Velanox sie über ihren Tunnel ab.",
  "devices.mikrotik.vpn.connected": "Verbunden",
  "devices.mikrotik.vpn.waiting": "Wartet auf die Einheit",
  "devices.mikrotik.vpn.noAccount": "Diese Einheit hat noch kein VPN-Zertifikat: Fügen Sie sie mit derselben Seriennummer erneut hinzu, um eines auszustellen.",
  "devices.mikrotik.vpn.tunnelAddress": "Tunneladresse",
  "devices.mikrotik.vpn.lastSeen": "Zuletzt verbunden",
  "devices.mikrotik.vpn.never": "Nie",
  "devices.mikrotik.vpn.downloadOvpn": ".ovpn herunterladen",
  "devices.mikrotik.vpn.downloadP12": ".p12 herunterladen",
  "devices.mikrotik.vpn.newCert": "Neues Zertifikat",
  "devices.mikrotik.vpn.newCertConfirm": "Ein neues VPN-Zertifikat für {name} ausstellen? Das aktuelle funktioniert sofort nicht mehr; die Einheit bleibt ohne VPN, bis sie die neuen Dateien hat.",
  "devices.mikrotik.vpn.newCertDone": "Neues Zertifikat ausgestellt",
  "devices.mikrotik.vpn.newCertDoneText": "Laden Sie die neuen Dateien herunter und spielen Sie sie auf die Einheit.",
  "devices.mikrotik.vpn.newCertFailed": "Es wurde kein neues Zertifikat ausgestellt",
  "devices.mikrotik.vpn.passphrase": "Passphrase dieser .p12:",
  "devices.mikrotik.vpn.passphraseHint": "Nur einmal angezeigt, nur für diesen Download; sie wird nicht gespeichert. Jeder Download erhält eine neue.",
  "devices.mikrotik.vpn.passphraseWord": "Passphrase",
  "devices.mikrotik.vpn.commands": "Befehle für RouterOS 7.17 oder neuer",
  "devices.mikrotik.vpn.commandsHint": "Laden Sie beide Dateien auf die Einheit (Files) und fügen Sie dann diese Befehle in ihr Terminal ein.",
  "devices.mikrotik.band.open": "Ein- oder ausschalten, Frequenz ändern",
  "devices.mikrotik.band.on": "Funkmodul an",
  "devices.mikrotik.band.frequency": "Frequenz",
  "devices.mikrotik.band.auto": "Automatisch",
  "devices.mikrotik.band.channel": "{mhz} MHz · Kanal {n}",
  "devices.mikrotik.band.followsAp": "Eine Station folgt der Frequenz ihres Access Points",
  "devices.mikrotik.band.offWarning": "{name} trägt eine Funkverbindung. Ausschalten trennt diese Verbindung: Die Einheit am anderen Ende ist darüber nicht mehr erreichbar. Wird auch diese Einheit getrennt, schaltet sie das Funkmodul nach 10 Minuten von selbst wieder ein. {name} ausschalten?",
  "devices.mikrotik.band.applied": "Funkeinstellungen übernommen",
  "devices.mikrotik.band.applying": "Wird übernommen. Trennt die Änderung die Verbindung, kann das zwei Minuten dauern.",
  "devices.mikrotik.band.apply": "Übernehmen",
  "devices.vpnPath": "Über die eigene VPN-Verbindung erreicht: Laden Sie nach dem Hinzufügen die .ovpn-Datei des Standorts als OpenVPN-Client auf den Router. Jetzt muss nichts erreichbar sein.",
  "devices.vpnAdded": "Standort hinzugefügt",
  "devices.vpnAddedText": "Laden Sie die .ovpn-Datei auf den Router; der Standort ist online, sobald er sich verbindet",
  "devices.teltonika.sim.title": "SIM-Karte",
  "devices.teltonika.sim.slot": "SIM {slot}",
  "devices.teltonika.sim.active": "Aktiv",
  "devices.teltonika.sim.locked": "Mit PIN gesperrt",
  "devices.teltonika.sim.unlocked": "Nicht gesperrt",
  "devices.teltonika.sim.blocked": "Gesperrt: PUK nötig",
  "devices.teltonika.sim.unknown": "Unbekannt",
  "devices.teltonika.sim.pinTries": "Verbleibende PIN-Versuche: {count}",
  "devices.teltonika.sim.pukTries": "Verbleibende PUK-Versuche: {count}",
  "devices.teltonika.sim.usesCompany": "Firmen-PIN",
  "devices.teltonika.sim.usesOwn": "Eigene PIN",
  "devices.teltonika.sim.usesOwnNote": "Eigene PIN · {note}",
  "devices.teltonika.sim.usesNone": "Keine PIN bekannt",
  "devices.teltonika.sim.storedMatches": "Im Router gespeicherte PIN: stimmt",
  "devices.teltonika.sim.storedDiffers": "Im Router gespeicherte PIN: stimmt nicht",
  "devices.teltonika.sim.storedUnknown": "Im Router gespeicherte PIN: unbekannt",
  "devices.teltonika.sim.inactive": "Nicht die aktive SIM: Ihr Stand ist von ihrer letzten aktiven Zeit.",
  "devices.teltonika.sim.switchFirst": "Zuerst zu dieser SIM wechseln",
  "devices.teltonika.sim.lockCompany": "Mit Firmen-PIN sperren",
  "devices.teltonika.sim.useOwn": "Eigene PIN verwenden",
  "devices.teltonika.sim.change": "PIN ändern",
  "devices.teltonika.sim.unlock": "Entsperren",
  "devices.teltonika.sim.unblockPuk": "Mit PUK entsperren",
  "devices.teltonika.sim.store": "Im Router gespeicherte PIN",
  "devices.teltonika.sim.currentPin": "Die aktuelle PIN der SIM",
  "devices.teltonika.sim.carrierHint": "eine neue SIM: die PIN des Anbieters",
  "devices.teltonika.sim.keptHint": "leer: die PIN, die Velanox speichert",
  "devices.teltonika.sim.newPin": "Neue PIN (4 bis 8 Ziffern)",
  "devices.teltonika.sim.simPin": "Die PIN der SIM",
  "devices.teltonika.sim.puk": "PUK (8 Ziffern)",
  "devices.teltonika.sim.note": "Notiz",
  "devices.teltonika.sim.noteHint": "z. B. Leih-SIM von …",
  "devices.teltonika.sim.toCompany": "Die Firmen-PIN verwenden",
  "devices.teltonika.sim.lastTryConfirm": "Noch ein Versuch. Eine falsche PIN sperrt die SIM jetzt, bis ihr PUK eingegeben wird. Fortfahren?",
  "devices.teltonika.sim.doneSteps": "Erledigt: {steps}",
  "devices.teltonika.sim.failedStep": "Nicht erledigt: {step}",
  "devices.teltonika.sim.step.change_pin": "PIN geändert",
  "devices.teltonika.sim.step.check_on": "PIN-Abfrage an",
  "devices.teltonika.sim.step.check_off": "PIN-Abfrage aus",
  "devices.teltonika.sim.step.unblock": "SIM entsperrt",
  "devices.teltonika.sim.step.store": "im Router gespeicherte PIN gesetzt",
  "devices.teltonika.sim.step.read": "Stand gelesen",
  "devices.teltonika.sim.needsDirect": "Zum Ändern der PIN der SIM ist die direkte oder VPN-Verbindung des Routers nötig.",
  "devices.teltonika.sim.notRead": "Die SIM-Karte wird bei der nächsten Synchronisierung gelesen.",
  "devices.teltonika.sim.pinTriesUnknown": "Verbleibende PIN-Versuche: unbekannt",
  "devices.teltonika.sim.unknownTriesConfirm": "Die verbleibenden Versuche sind nicht lesbar: Dies könnte der letzte sein, und eine falsche PIN oder ein falscher PUK würde die SIM sperren. Fortfahren?",
  "devices.teltonika.sim.lastPukConfirm": "Noch ein PUK-Versuch. Ein falscher PUK macht die SIM jetzt endgültig unbrauchbar: Nur ihr Anbieter kann sie ersetzen. Fortfahren?",
  "devices.accessFix.teltonika": "Führen Sie dies einmal auf dem Router aus, um den VPN-Server von Velanox {serverIp} zuzulassen: in der WebUI unter System → Maintenance → CLI oder per SSH aus dem eigenen Netzwerk des Routers.",
  "devices.accessFix.peplink": "Die API bietet dafür keinen Aufruf: Erlauben Sie im Web Admin des Routers unter System → Admin Security HTTPS (Port 443) und die Quelladresse {serverIp} (der VPN-Server von Velanox) auf der Verbindung, die das VPN nutzt.",
  "devices.accessFix.copy": "Befehl kopieren",
}

export default devices
